import Moderator from '@/models/bread/Moderator/upgradeRequest'

export default {
  key:'UpgradeRequest',
  server:'sso',
  name:{
    singular:'UpgradeRequest',
    plural:'UpgradeRequests',
  },
  parents:[
  ],
  Admin:false,
  Moderator:Moderator,
  Teacher:false,
}